import {
    REQUEST_PROPMIXSSO, RECEIVE_PROPMIXSSO, ERROR_PROPMIXSSO,
    REQUEST_COMPARABLEDETAILS, RECEIVE_COMPARABLEDETAILS, ERROR_COMPARABLEDETAILS, 
    RECEIVE_GRIDDATA, ERROR_GRIDDATA, REQUEST_GRIDDATA_POST, RECEIVE_GRIDDATA_POST, ERROR_GRIDDATA_POST
} from "typeConstants";
import { comparable as initialState } from "reducers/initialState.tsx";

const comparable = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_COMPARABLEDETAILS:
            return {
                ...state,
                fetchingComparableDetails: true
            };
        case RECEIVE_COMPARABLEDETAILS:
            return {
                ...state,
                comparableDetails: action.payload,
                fetchingComparableDetails: false
            };
        case ERROR_COMPARABLEDETAILS:
            return {
                ...state,
                fetchingComparableDetails: false
            };
        case REQUEST_PROPMIXSSO:
            return {
                ...state,
                fetchingPropmixSsoUrl: true
            };
        case RECEIVE_PROPMIXSSO:
            return {
                ...state,
                comparable: action.payload,
                fetchingPropmixSsoUrl: false
            };
        case ERROR_PROPMIXSSO:
            return {
                ...state,
                fetchingPropmixSsoUrl: false
            };
        case RECEIVE_GRIDDATA:
            return {
                ...state,
                gridData: action.payload,
                fetchingGridData: false
            };
        case ERROR_GRIDDATA:
            return {
                ...state,
                fetchingGridData: false
            };
        case REQUEST_GRIDDATA_POST:
            return {
                ...state,
                postingGridData: true
            };
        case RECEIVE_GRIDDATA_POST:
            return {
                ...state, 
                gridData: { ...state.gridData, compGrid: action.payload},
                postingGridData: false
            };
        case ERROR_GRIDDATA_POST:
            return {
                ...state,
                postingGridData: false
            };
        default:
            return state;
    }
};

export default comparable;
